module.exports = __webpack_public_path__ + "media/images/favicons/144x144-ff5813aa305acf606e8af5dc3e3c2e1d.png";